var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{class:[
    _vm.$style.wrapper,
    ( _obj = {}, _obj[_vm.$style.grey] = _vm.variant === 'grey', _obj[_vm.$style.yellow] = _vm.variant === 'yellow', _obj[_vm.$style.black] = _vm.variant === 'black', _obj[_vm.$style.blue] = _vm.variant === 'blue', _obj[_vm.$style.green] = _vm.variant === 'green', _obj[_vm.$style.white] = _vm.variant === 'white', _obj ) ]},[_c('Typography',{attrs:{"variant":_vm.TYPOGRAPHY_TYPES.bodySmallBold}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }